module.exports = __webpack_public_path__ + "img/ring_y_s_null_0@3x.6fb55e09.png";